import { render, staticRenderFns } from "./RequestedAttestations.vue?vue&type=template&id=0385fad9&scoped=true&"
import script from "./RequestedAttestations.vue?vue&type=script&lang=js&"
export * from "./RequestedAttestations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0385fad9",
  null
  
)

export default component.exports